module.exports = __webpack_public_path__ + "static/media/taffiethule14.c83d27e7.jpg";